// include all desired services as dependencies here
define('vspot-services',['angular', 'vspot-resources',
    'vspot-angular/services/user-service',
    'vspot-angular/services/google-service',
    'vspot-angular/services/googlerecaptcha-service',
    'vspot-angular/services/form-entries-service',
    'vspot-angular/services/group-service',
    'vspot-angular/services/org-group-service',
    'vspot-angular/services/school-service',
    'vspot-angular/services/org-activity-service',
    'vspot-angular/services/org-dashboard-pins-service',
    'vspot-angular/services/org-jobs-service',
    'vspot-angular/services/org-signup-service',
    'vspot-angular/services/org-job-titles-service',
    'vspot-angular/services/job-assignment-service',
    'vspot-angular/services/org-job-assignment-service',
    'vspot-angular/services/job-service',
    'vspot-angular/services/org-invitation-service',
    'vspot-angular/services/org-volunteer-service',
    'vspot-angular/services/pledge-service',
    'vspot-angular/services/activity-type-service',
    'vspot-angular/services/activity-themes-service',
    'vspot-angular/services/categories-service',
    'vspot-angular/services/activity-badges-service',
    'vspot-angular/services/activity-tags-service',
    'vspot-angular/services/org-event-service',
    'vspot-angular/services/utilities-service',
    'vspot-angular/services/message-service',
    'vspot-angular/services/organizer-service',
    'vspot-angular/services/email-utils-service',
    'vspot-angular/services/reports-service',
    'vspot-angular/services/wepay-service',
    'vspot-angular/services/paypal-service',
    'vspot-angular/services/comment-service',
    'vspot-angular/services/cookie-service',
    'vspot-angular/services/coreg-service',
    'vspot-angular/services/invitation-service',
    'vspot-angular/services/organization-service',
    'vspot-angular/services/activity-service',
    'vspot-angular/services/activity-limit-service',
    'vspot-angular/services/org-lists-service',
    'vspot-angular/services/admin-service',
    'vspot-angular/services/login-service',
    'vspot-angular/services/calendar-service',
    'vspot-angular/services/tracking-service',
    'vspot-angular/services/page-unload-service',
    'vspot-angular/services/job-compose-service',
    'vspot-angular/services/nlytcs-service',
    'vspot-angular/services/charges-service',
    'vspot-angular/services/event-service',
    'vspot-angular/services/org-teachers-service',
    'vspot-angular/services/volunteer-service',
    'vspot-angular/services/page-categories-service',
    'vspot-angular/services/assigners-service',
    'vspot-angular/services/waitlist-service',
    'vspot-angular/services/browser-info-service'
    ],

    function (
        angular,
        resources,
        User,
        googleUser,
        googleReCaptcha,
        FormEntries,
        Group,
        OrgGroup,
        School,
        OrgActivity,
        OrgDashboardPins,
        OrgJobs,
        OrgSignup,
        OrgJobTitles,
        JobAssignment,
        OrgJobAssignment,
        Job,
        OrgInvitation,
        OrgVolunteer,
        Pledge,
        ActivityType,
        ActivityThemes,
        Categories,
        ActivityBadges,
        ActivityTags,
        OrgEvent,
        Utilities,
        Message,
        Organizer,
        EmailUtils,
        Reports,
        WePay, // Used to be OrgWePay
        PayPal,
        Comment,
        Cookie,
        Coreg,
        Invitation,
        Organization,
        Activity,
        ActivityLimit,
        OrgLists,
        Admin,
        Login,
        Calendar,
        Tracking,
        PageUnload,
        JobCompose,
        Nlytcs,
        Charges,
        EventSvc,
        OrgTeachers,
        Volunteer,
        PageCategories,
        Assigners,
        Waitlist,
        BrowserInfo
    ) {

    'use strict';

    /*
     *  Services
     *
     *  Services are used to share common, reusable code across the application. For now,
     *  their main use is to act as an intermediary between resources and controllers.
     *  Actions that communicate with the server, and then require the same business
     *  logic over and over to process and respond to the returned data, should be moved
     *  to a service.
     *
     *  Additional clarification should be added as this is used more frequently across
     *  the application.
     */

    // list all available services here
    var services = {
        'services.User':                User,
        'services.googleUser':          googleUser,
        'services.googleReCaptcha':     googleReCaptcha,
        'services.FormEntries':         FormEntries,
        'services.Group':               Group,
        'services.OrgGroup':            OrgGroup,
        'services.School':              School,
        'services.OrgActivity':         OrgActivity,
        'services.OrgDashboardPins':    OrgDashboardPins,
        'services.OrgJobs':             OrgJobs,
        'services.OrgSignup':           OrgSignup,
        'services.OrgJobTitles':        OrgJobTitles,
        'services.JobAssignment':       JobAssignment,
        'services.OrgJobAssignment':    OrgJobAssignment,
        'services.Job':                 Job,
        'services.OrgInvitation':       OrgInvitation,
        'services.OrgVolunteer':        OrgVolunteer,
        'services.Pledge':              Pledge,
        'services.ActivityType':        ActivityType,
        'services.ActivityThemes':      ActivityThemes,
        'services.Categories':          Categories,
        'services.ActivityBadges':      ActivityBadges,
        'services.ActivityTags':        ActivityTags,
        'services.OrgEvent':            OrgEvent,
        'services.Utilities':           Utilities,
        'services.Message':             Message,
        'services.Organizer':           Organizer,
        'services.EmailUtils':          EmailUtils,
        'services.Reports':             Reports,
        'services.WePay':               WePay, // Used to be OrgWePay
        'services.PayPal':              PayPal, // Used to be OrgWePay
        'services.Comment':             Comment,
        'services.Cookie':              Cookie,
        'services.Coreg':               Coreg,
        'services.Invitation':          Invitation,
        'services.Organization':        Organization,
        'services.Activity':            Activity,
        'services.ActivityLimit':       ActivityLimit,
        'services.OrgLists':            OrgLists,
        'services.Admin':               Admin,
        'services.Login':               Login,
        'services.Calendar':            Calendar,
        'services.Tracking':            Tracking,
        'services.PageUnload':          PageUnload,
        'services.JobCompose':          JobCompose,
        'services.Nlytcs':              Nlytcs,
        'services.Charges':             Charges,
        'services.EventSvc':            EventSvc,
        'services.OrgTeachers':         OrgTeachers,
        'services.Volunteer':           Volunteer,
        'services.PageCategories':      PageCategories,
        'services.Assigners':           Assigners,
        'services.Waitlist':            Waitlist,
        'services.BrowserInfo':         BrowserInfo
    };

    var serviceModule = angular.module('vspot.services', ['vspot.resources']);

    for (var service in services) {
        serviceModule.factory(service, services[service]);
    }
});
